'use strict';

/** @type {import('./max')} */
module.exports = Math.max;



//////////////////
// WEBPACK FOOTER
// ../~/math-intrinsics/max.js
// module id = 1861
// module chunks = 1